import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Divider, Spin, Image } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { DateTimeFormat } from "../../components/FormattersTS";
import API from "../../../../API";
const VehicleHireSignatureList = ({ vehicleHireId }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [signatureList, setSignatureList] = useState(undefined);
    useEffect(() => {
        if (vehicleHireId) {
            loadSignatures();
        }
    }, [vehicleHireId]);
    const loadSignatures = () => {
        setNetworkRequestInProgress(true);
        axios.get(`/admin/v1/vehicle-hires/${vehicleHireId}/signatures`).then(response => {
            setSignatureList(response.data);
        }).catch(axiosErrorHandler).finally(() => setNetworkRequestInProgress(false));
    };
    return (_jsx(Spin, { spinning: networkRequestInProgress, children: _jsx("div", { style: {
                height: 400,
                overflow: 'auto',
                padding: '0 16px 0 0', // Cater for the vert scrollbar, without this a horizontal scrollbar will appear
            }, children: signatureList && signatureList.length > 0 && signatureList.map(signature => {
                return (_jsxs("div", { children: [_jsx("h4", { children: signature.isPickup ? "Pickup Signature" : "Customer Signature" }), _jsx("p", { children: _jsx(Image, { src: `${API.origin()}/admin/v1/vehicle-hires/${vehicleHireId}/signatures/${signature.id}/content`, width: "200", height: "auto" }) }), _jsxs("p", { children: [signature.signedByFirstName, " ", signature.signedByLastName, _jsx("br", {}), _jsxs("small", { children: ["Created at: ", _jsx(DateTimeFormat, { value: signature.createdAt })] })] }), _jsx(Divider, { orientation: "horizontal" })] }, signature.id));
            }) }) }));
};
export default VehicleHireSignatureList;
